export default __webpack_public_path__ + "static/media/ProibiçãoMinisterial.f5fa330b.pdf";